export default __webpack_public_path__ + "static/media/gallery32.8acb2c3f.jpg";